import {QuickActions} from "../enums/quick-actions.enum";
import {UserQuickActionButton} from "../user-quick-action-button.model";

export const QUICK_ACTION_BUTTON_CONFIGURATION:Map<QuickActions,UserQuickActionButton> = new Map();

QUICK_ACTION_BUTTON_CONFIGURATION.set(QuickActions.CREATE_PAYMENT,{
  quickAction:QuickActions.CREATE_PAYMENT,
  id:'landing-page-create-payment',
  azureId:'landing-page-create-payment',
  icon:'pencil',
  text:'messages_center.landing_page.create_payment',
  class:'landing-page-create-payment'
});

QUICK_ACTION_BUTTON_CONFIGURATION.set(QuickActions.SEARCH_PAYMENT,{
  quickAction:QuickActions.SEARCH_PAYMENT,
  id:'landing-page-search-a-payment',
  azureId:'landing-page-search-a-payment',
  icon:'search',
  text:'messages_center.landing_page.search_payment',
});

QUICK_ACTION_BUTTON_CONFIGURATION.set(QuickActions.RECENT_SEARCH,{
  quickAction:QuickActions.RECENT_SEARCH,
  id:'landing-page-recent-queues-view',
  azureId:'landing-page-recent-queues-view',
  icon:'clock',
  text:'messages_center.landing_page.recent_searches',
});
QUICK_ACTION_BUTTON_CONFIGURATION.set(QuickActions.CREATE_CUSTOMER_PAYMENT,{
  quickAction:QuickActions.CREATE_CUSTOMER_PAYMENT,
  id:'landing-page-create-customer-payment',
  azureId:'landing-page-create-customer-payment',
  icon:'file-document-outline',
  text:'messages_center.landing_page.change_quick_actions.create_customer_payment',
  class:'landing-page-create-customer-payment'
})

QUICK_ACTION_BUTTON_CONFIGURATION.set(QuickActions.CREATE_FX_PAYMENT,{
  quickAction:QuickActions.CREATE_FX_PAYMENT,
  id:'landing-page-create-fx-payment',
  azureId:'landing-page-create-fx-payment',
  icon:'file-arrow-up-down-outline',
  text:'messages_center.landing_page.change_quick_actions.create_fx_payment',
  class:'landing-page-create-fx-payment'
})

QUICK_ACTION_BUTTON_CONFIGURATION.set(QuickActions.CREATE_CUSTOMER_PAYMENT_TEMPLATE,{
  quickAction:QuickActions.CREATE_CUSTOMER_PAYMENT_TEMPLATE,
  id:'landing-page-create-payment-template',
  azureId:'landing-page-create-payment-template',
  icon:'file-document-edit-outline',
  text:'messages_center.landing_page.change_quick_actions.create_customer_payment_template',
  class:'landing-page-create-payment-template'
});

QUICK_ACTION_BUTTON_CONFIGURATION.set(QuickActions.CREATE_REQUEST_FOR_PAYMENT,{
  quickAction:QuickActions.CREATE_REQUEST_FOR_PAYMENT,
  id:'landing-page-create-request-for-payment',
  azureId:'landing-page-create-request-for-payment',
  icon:'invoice-list-outline',
  text:'messages_center.landing_page.change_quick_actions.create_request_for_payment',
  class:'landing-page-create-request-for-payment'
});

QUICK_ACTION_BUTTON_CONFIGURATION.set(QuickActions.CREATE_REQUEST_FOR_PAYMENT_TEMPLATE,{
  quickAction:QuickActions.CREATE_REQUEST_FOR_PAYMENT_TEMPLATE,
  id:'landing-page-create-request-for-payment-template',
  azureId:'landing-page-create-request-for-payment-template',
  icon:'invoice-text-edit-outline',
  text:'messages_center.landing_page.change_quick_actions.create_request_for_payment_template',
  class:'landing-page-create-request-for-payment-template'
});





